import Vue from 'vue';
export const EventBus = new Vue(); // 创建一个新的 Vue 实例作为事件总线